export default import.meta.ROLLUP_FILE_URL_KGE4ixq11q$QXaMSQ1ODkg